enum CurrentState{
    FirstLoginForm = "FIRSTLOGINFORM",
    SecondaryAuthForm = "SECONDARYAUTHFORM",
    OTPForm = "OTPFORM",
    Finished = "Finished"
}

export default CurrentState;